import React, {useState} from 'react';
import NetworkApi from "../services/networks";
import Error from "../fragments/form/Error"
import Message from "../fragments/form/Message"

import TextValue from "../fragments/table/TextValue"
import ItemActions from "../fragments/table/ItemActions"

function NetworksTable (props) {
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);
    const networkApi = new NetworkApi(props.token);

    function deleteNetwork(id, name){
        networkApi.delete(id).then((response) => {
            setMessage(`Network "${name}" has been deleted`)
            setError("");
            props.refresh();
        })
        .catch((err) => {
            console.error(err.message);
            const errorMessage = err.response?.data?.message || err.message;
            setError(errorMessage);
            setMessage("");
        });
    }

    return(
        <div>
            <Error message={error} />
            <Message message={message} />
            <table>
                <tbody>
                    <tr>
                        <th>ID</th>
                        <th>NAME</th>
                        <th>DOMAIN</th>
                        <th>ADMINISTRATOR</th>
                        <th>STATUS</th>
                        <th>ACTIONS</th>
                    </tr>

                    {props.networks.map((network, index) => (
                        <tr key={index}>
                            <td><TextValue value={network.id} /></td>
                            <td><TextValue value={network.name} /></td>
                            <td><TextValue value={network.domain} /></td>
                            <td><TextValue value={network.administrator_name} /></td>
                            <td><TextValue value={network.is_published ? 'Published': 'Pending'} /></td>
                            <td><ItemActions
                                    onConfirm={() => deleteNetwork(network.id, network.name)}
                                    editUrl={`/network/${network.id}/edit`}
                                    viewUrl={`/network/${network.id}`}
                                    itemName={`network "${network.name}"`}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default NetworksTable;
